<template>
  <card-seplag titulo="Novo Questionario Perguntas" cor="#00acc1">
    <Rotulo nome="Numero:" cols="12 4">
      <InputText type="number" v-model="novoquestionarioPergunta.numrPergunta" />
    </Rotulo>
    <Rotulo nome="Ordem:" cols="12 4">
      <InputText
        type="number"
        v-model="novoquestionarioPergunta.numrOrdemPergunta"
      />
    </Rotulo>
    <Rotulo nome="Obrigaório:" cols="12 4">
      <SelectButton
        v-model="novoquestionarioPergunta.flagButton"
        :options="simNao"
        optionLabel="name"
      />
    </Rotulo>
    <div class="p-col-12">
      <Fieldset legend="Categoria">
        <div class="p-col-12 p-md-3 p-md-offset-9">
          <Button
            label="Nova Categoria"
            icon="pi pi-check"
            class="p-button-rounded"
            @click="mostrarNovaCategoria()"
          />
        </div>
        <table-seplag
          :dados.sync="listaCategoria"
          :exibirCabecalho="false"
          :paginacao="true"
          :urlPanagicao="'categoriaperguntas/status/ATIVO'"
          :totalRegistro="totalRegistroCategoria"
        >
          <Column
            bodyStyle="text-align: center"
            header="Selecione"
            :headerStyle="'width: 8em'"
          >
            <template #body="slotProps">
              <RadioButton
                :id="slotProps.data.idenCategoriaPergunta"
                :name="slotProps.data.descrCategoriaPergunta"
                :value="slotProps.data"
                v-model="novoquestionarioPergunta.categoriaPergunta"
              />
            </template>
          </Column>
          <Column bodyStyle="text-align: center" header="Descrição">
            <template #body="slotProps">
              {{ slotProps.data.descrCategoriaPergunta }}
            </template>
          </Column>
          <Column
            bodyStyle="text-align: center"
            headerStyle="width: 15em;"
            class="p-grid"
          >
            <template #body="linha">
              <Button
                v-tooltip="'Editar'"
                icon="pi pi-pencil"
                class="p-button-rounded p-button-warning margin-botao"
                @click=" mostrarEditarCategoria(linha.data)"
              />
              <Button
                v-tooltip="'Deletar'"
                icon="pi pi-trash"
                class="p-button-rounded p-button-danger margin-botao"
                @click="mostrarExcluirCategoria(linha.data)"
              />
            </template>
          </Column>
        </table-seplag>

        <!-- MODAL NOVA CATEGORIA -->
        <cadastro-rapido
          tituloTela="Nova Categoria"
           tamanhoTela="360"
          v-model="exibirNovaCategoria"
           :modoEdicao="'adicionar'"
          :onAdicionar="criarNovaCategoria"
        >
          <div class="p-grid p-fluid">
            <Rotulo nome="Descrição:" cols="12">
              <InputText
                type="text"
                v-model="novaCategoria.descrCategoriaPergunta"
              />
            </Rotulo>
          </div>
        </cadastro-rapido>
        <!-- MODAL NOVA PERGUNTA -->
        <cadastro-rapido
          tituloTela="Nova Pergunta"
          tamanhoTela="360"
          alturaTela="280"
          v-model="exibirNovaPergunta"
          :modoEdicao="'adicionar'"
          :onAdicionar="criarNovaPergunta"
        >
          <div class="p-grid p-fluid">
            <Rotulo nome="Descrição da Pergunta:" cols="12">
              <InputText
                type="text"
                v-model="pergunta.descPergunta"
                v-required
              />
            </Rotulo>
            <Rotulo nome="Tipo da Pergunta:" cols="12">
              <Dropdown
                v-model="tipoSelecionado"
                :options="tipoPerguntaList"
                optionLabel="descTipoPergunta"
                :placeholder="textoPadrao ? textoPadrao : 'Selecione a opção'"
              >
              </Dropdown>
            </Rotulo>
          </div>
        </cadastro-rapido>


        <!-- MODAL ALTERAR CATEGORIA -->
        <cadastro-rapido
          tituloTela="Editar Categoria"
           tamanhoTela="360"
          v-model="exibirEditarCategoria"
           :modoEdicao="'alterar'"
          :onAlterar="editarCategoria"
        >
          <div class="p-grid p-fluid">
            <Rotulo nome="Descrição:" cols="12">
              <InputText
                type="text"
                v-model="novaCategoria.descrCategoriaPergunta"
              />
            </Rotulo>
          </div>
        </cadastro-rapido>
        <!-- MODAL ALTERAR PERGUNTA -->
        <cadastro-rapido
          tituloTela="Editar Pergunta"
          tamanhoTela="360"
          alturaTela="280"
          v-model="exibirEditarPergunta"
          :modoEdicao="'alterar'"
          :onAlterar="editarPergunta"
        >
          <div class="p-grid p-fluid">
            <Rotulo nome="Descrição da Pergunta:" cols="12">
              <InputText
                type="text"
                v-model="pergunta.descPergunta"
                v-required
              />
            </Rotulo>
            <Rotulo nome="Tipo da Pergunta:" cols="12">
              <Dropdown
                v-model="tipoSelecionado"
                :options="tipoPerguntaList"
                optionLabel="descTipoPergunta"
                :placeholder="textoPadrao ? textoPadrao : 'Selecione a opção'"
                 >
              </Dropdown>
            </Rotulo>
          </div>
        </cadastro-rapido>

        <!-- MODAL EXCLUIR CATEGORIA -->
        <cadastro-rapido
          tituloTela="Excluir Categoria"
           tamanhoTela="360"
          v-model="exibiExcluirCategoria"
           :modoEdicao="'excluir'"
          :onAlterar="excluirCategoria"
        >
          <div class="p-grid p-fluid">
            <Rotulo nome="Descrição:" cols="12">
              <InputText
                type="text"
                v-model="novaCategoria.descrCategoriaPergunta"
              />
            </Rotulo>
          </div>
        </cadastro-rapido>

        <!-- MODAL EXCLUIR PERGUNTA -->
        <cadastro-rapido
          tituloTela="Excluir Pergunta"
          tamanhoTela="360"
          v-model="exibirExcluirPergunta"
          :modoEdicao="'excluir'"
          :onAlterar="excluirPergunta"
        >
          <div class="p-grid p-fluid">
            <Rotulo nome="Descrição da Pergunta:" cols="12">
              <InputText
                type="text"
                v-model="pergunta.descPergunta"
                v-required
              />
            </Rotulo>
          </div>
        </cadastro-rapido>

        
      </Fieldset>
    </div>
    <div class="p-col-12">
      <Fieldset legend="Perguntas">
        <div class="p-col-12 p-md-3 p-md-offset-9">
          <Button
            label="Nova Pergunta"
            icon="pi pi-check"
            class="p-button-rounded"
            @click="mostrarNovaPergunta()"
          />
        </div>
        <table-seplag
          :dados.sync="listaPergunta"
          :exibirCabecalho="false"
          :paginacao="true"
          :urlPanagicao="'perguntas/status/ATIVO'"
          :totalRegistro="totalRegistroPergunta"
        >
          <Column
            bodyStyle="text-align: center"
            header="Selecione"
            :headerStyle="'width: 8em'"
          >
            <template #body="slotProps">
              <RadioButton
                :id="slotProps.data.idenPergunta"
                :name="slotProps.data.descPergunta"
                :value="slotProps.data"
                v-model="novoquestionarioPergunta.pergunta"
              />
            </template>
          </Column>
          <Column bodyStyle="text-align: center" header="Descrição">
            <template #body="slotProps">
              {{ slotProps.data.descPergunta }}
            </template>
          </Column>
          <Column bodyStyle="text-align: center" header="Tipo">
            <template #body="slotProps">
              {{ slotProps.data.descTipoPergunta }}
            </template>
          </Column>
           <Column
            bodyStyle="text-align: center"
            headerStyle="width: 15em;"
            class="p-grid"
          >
            <template #body="linha">
              <Button
                v-tooltip="'Editar'"
                icon="pi pi-pencil"
                class="p-button-rounded p-button-warning margin-botao"
                @click="mostrarEditarPergunta(linha.data)"
              />
              <Button
                v-tooltip="'Deletar Pergunta'"
                icon="pi pi-trash"
                class="p-button-rounded p-button-danger margin-botao"
                @click="mostrarExcluirPergunta(linha.data)"
              />
               <Button
                v-tooltip="'Incluir opções pergunta'"
                icon="pi pi-list"
                class="p-button-rounded p-button-success margin-botao"
                @click="mostrarOpcaoPergunta(linha.data)"
              />
            </template>
          </Column>
        </table-seplag>
      </Fieldset>
    </div>

    <div class="p-col-12">
      <div class="p-grid p-fluid">
        <div class="p-col-12 p-md-3">
          <Button
            label="Lista de Pergunta do Questionário"
            icon="pi pi-arrow-left"
            class="p-button-rounded"
            @click="voltarTelaQuestionario()"
          />
        </div>
        <div class="p-col-12 p-md-3">
          <Button
            label="Vincular ao Questionário"
            icon="pi pi-check"
            class="p-button-rounded p-button-success"
            @click="vincularPerguntaECategoriaAQuestionario()"
          />
        </div>
      </div>
    </div>
  </card-seplag>
</template>

<script>
import CardSeplag from "@/template/CardSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import TableSeplag from "@/template/TableSeplag.vue";
import CadastroRapido from "@/template/CadRapidoSeplag.vue";

import { simNao, baseApiUrl } from "@/config/global";
export default {
  name: "novoQuestionarioPergunta",
  components: { CardSeplag, Rotulo, TableSeplag, CadastroRapido },
  data: function() {
    return {
      novoquestionarioPergunta: {
        pergunta: null,
        categoriaPergunta: null,
        numrPergunta: null,
        numrOrdemPergunta: null,
        flagObrigatorio: null,
        flagButton: { name: "Não", code: "N" },
      },
      novasperguntaSelecionadasParaQuestionario : [],
      questionarioPerguntas: [],
      listaPergunta: [],
      listaCategoria: [],
      categorias: [],
      simNao: simNao,

      exibirNovaCategoria: false,
      exibirNovaPergunta: false,
      exibirEditarCategoria: false,
      exibirEditarPergunta: false,
      exibiExcluirCategoria: false,
      exibirExcluirPergunta: false,
      totalRegistroCategoria: 0,
      totalRegistroPergunta: 0,
      novaCategoria: {
        descrCategoriaPergunta: null,
        statCategoriaPergunta: 'ATIVO',
        idenCategoriaPerguntaPai: null,
      },
      pergunta: {
        tipoPergunta: { idenTipoPergunta: 0 },
        idenPergunta : 0,
        descPergunta: " ",
        mascaraPergunta: null,
        colsGrid: null,
        statPergunta:'ATIVO',
      },
      tipoPerguntaList: [],
      tipoSelecionado: null,
      textoPadrao: "Selecione um tipo de pergunta",

    
      /* JsonObjectPergunta  :   {
        pergunta: {
        idenPergunta: null
                 },
       categoriaPergunta: {
        idenCategoriaPergunta: null
         },
      numrPergunta: null,
      numrOrdemPergunta:null,
      flagObrigatorio: null,
      statQuestionarioPergunta: null,
      infoDependencia: null,
      idenQuestionario: null,
     
}, */
     questionario: {},
    };
  },
  methods: {
    carregarDados() {
     this.questionario =  JSON.parse(
        JSON.stringify(this.$store.getters.getQuestionarioSelecionado));

      this.questionarioPerguntas = JSON.parse(
        JSON.stringify(this.$store.getters.getPerguntasQuestionario)
      );
       
         this.novasperguntaSelecionadasParaQuestionario = JSON.parse(
        JSON.stringify(this.$store.getters.getNovasperguntaSelecionadasParaQuestionario)
      );
          this.$http
            .get(`${baseApiUrl}/categoriaperguntas/status/ATIVO?size=10&page=0`)
            .then((res) => {
              this.listaCategoria = res.data.content;
              this.totalRegistroCategoria = res.data.totalElements;
            });
      // this.novoquestionarioPergunta.idenQuestionario = this.questionario.idenQuestionario;


      this.$http.get(`${baseApiUrl}/perguntas/status/ATIVO?size=10&page=0`).then((res) => {
        this.listaPergunta = res.data.content;
        this.totalRegistroPergunta = res.data.totalElements;
      });


      this.$http.get(`${baseApiUrl}/tipoperguntas/all`).then((res) => {
        this.tipoPerguntaList = res.data;
      });
         /* this.$http.get(`${baseApiUrl}/opcaoperguntas/all`).then(res =>{
              this.opcoesPergunta = res.data
           }) */
    },
    vincularPerguntaECategoriaAQuestionario() {
      const   jsonObjectNovoquestionarioPergunta = {   pergunta: null,
                                                      categoriaPergunta: null,
                                                      numrPergunta: null,
                                                      numrOrdemPergunta: null,
                                                      flagObrigatorio: null,
                                                      flagButton: { name: "Não", code: "N" },
      };
      if (this.novoquestionarioPergunta.pergunta != null) {
        if (this.novoquestionarioPergunta.categoriaPergunta) {
          this.novoquestionarioPergunta.flagObrigatorio = this.novoquestionarioPergunta.flagButton.code;
          jsonObjectNovoquestionarioPergunta.categoriaPergunta = this.novoquestionarioPergunta.categoriaPergunta;
          jsonObjectNovoquestionarioPergunta.pergunta = this.novoquestionarioPergunta.pergunta;          
           jsonObjectNovoquestionarioPergunta.pergunta = {...jsonObjectNovoquestionarioPergunta.pergunta,  tipoPergunta : { descTipoPergunta : ""}}
           jsonObjectNovoquestionarioPergunta.pergunta.tipoPergunta.descTipoPergunta = this.novoquestionarioPergunta.pergunta.descTipoPergunta;
           jsonObjectNovoquestionarioPergunta.statQuestionarioPergunta = "ATIVO";
           jsonObjectNovoquestionarioPergunta.flagObrigatorio = this.novoquestionarioPergunta.flagObrigatorio;
           jsonObjectNovoquestionarioPergunta.numrPergunta = this.novoquestionarioPergunta.numrPergunta;
           jsonObjectNovoquestionarioPergunta.numrOrdemPergunta = this.novoquestionarioPergunta.numrOrdemPergunta;
           jsonObjectNovoquestionarioPergunta.idenQuestionario = this.questionario.idenQuestionario;
             
        this.$http
        .post(`${baseApiUrl}/questionarioperguntas`, JSON.stringify(jsonObjectNovoquestionarioPergunta))
        .then(() => {
          this.$toast.add({severity:'success', summary: 'Aviso', detail:'Pergunta vinculada com sucesso', life: 4000});
          this.$http.post(`${baseApiUrl}/questionarios/${this.questionario.idenQuestionario}`).then((res) => {
            this.$store.commit('setQuestionarioSelecionado', res.data);
            this.$router.push({ name: "gerenciaNovoQuestionario" }); 
          })

        })
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Erro ao salvar",
            detail: "Selecionar uma categoria é obrigatório",
            life: 6000,
          });
        }
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Erro ao salvar",
          detail: "selecionar uma pergunta é obrigatório",
          life: 6000,
        });
      }
    },
    voltarTelaQuestionario() {
      this.$router.push({ name: "gerenciaNovoQuestionario" });
    },
    async criarNovaPergunta() {
      this.pergunta.idenPergunta = undefined;
      this.pergunta.tipoPergunta.idenTipoPergunta = this.tipoSelecionado.idenTipoPergunta;
      await this.$http
        .post(`${baseApiUrl}/perguntas`, JSON.stringify(this.pergunta))
        .then(() => {
          
           this.$http.get(`${baseApiUrl}/perguntas/status/ATIVO?size=10&page=0`).then((res2) => {
            this.listaPergunta = res2.data.content;
            this.totalRegistroPergunta = res2.data.totalElements;
      });
            this.$toast.add({severity:'success', summary: 'Aviso', detail:'Pergunta salva com sucesso', life: 4000});

        });
      },

     editarPergunta() {
       this.pergunta.tipoPergunta.idenTipoPergunta = this.tipoSelecionado.idenTipoPergunta;
        this.$http
        .put(`${baseApiUrl}/perguntas/${this.pergunta.idenPergunta}`, JSON.stringify(this.pergunta))
        .then(() => {
          
            this.$http.get(`${baseApiUrl}/perguntas/status/ATIVO?size=10&page=0`).then((res2) => {
            this.listaPergunta = res2.data.content;
            this.totalRegistroPergunta = res2.data.totalElements;
            this.$toast.add({severity:'success', summary: 'Aviso', detail:'Pergunta alterada com sucesso', life: 4000});

      });
        });
        
    },
     excluirPergunta() {
 this.$http.delete(`${baseApiUrl}/perguntas/${this.pergunta.idenPergunta}`)
        .then(() => {
           this.$http.get(`${baseApiUrl}/perguntas/status/ATIVO?size=10&page=0`).then((res2) => {
            this.listaPergunta = res2.data.content;
            this.totalRegistroPergunta = res2.data.totalElements;
            this.$toast.add({severity:'success', summary: 'Aviso', detail:'Pergunta excluída com sucesso', life: 4000});

      });
        });
    },
          async criarNovaCategoria() {
            await this.$http
              .post(
                `${baseApiUrl}/categoriaperguntas`,
                JSON.stringify(this.novaCategoria)
              )
              .then(() => {
                this.$toast.add({severity:'success', summary: 'Aviso', detail:'Categoria  criada com sucesso', life: 4000});

              });
          },
     async editarCategoria() {    
      await this.$http
        .put(`${baseApiUrl}/categoriaperguntas/${this.novaCategoria.idenCategoriaPergunta}`, JSON.stringify(this.novaCategoria))
        .then(() => {
          this.$toast.add({severity:'success', summary: 'Aviso', detail:'Categoria editada com sucesso', life: 4000});

        });
    },

    excluirCategoria() {
 this.$http.delete(`${baseApiUrl}/categoriaperguntas/${this.novaCategoria.idenCategoriaPergunta}`)
        .then(() => {
          this.$toast.add({severity:'success', summary: 'Aviso', detail:'Categoria excluída com sucesso', life: 4000});

        });
    },
    mostrarNovaCategoria() {
      this.exibirNovaCategoria = true;
    },
    mostrarNovaPergunta() {
      this.pergunta.descPergunta = '';
      this.exibirNovaPergunta = true;

    },
     mostrarEditarCategoria(data) {
       this.novaCategoria = data;
       // verificar a forma correta de obter o idenCategoriaPerguntaPai
       this.novaCategoria.idenCategoriaPerguntaPai = 1;
      this.exibirEditarCategoria = true;
    },
    mostrarEditarPergunta(data) {
      let stringFixed = "";
      this.pergunta.tipoPergunta.idenTipoPergunta = data.idenTipoPergunta;      
      this.pergunta.tipoPergunta.descTipoPergunta = data.descTipoPergunta;
      stringFixed = this.slugify(data.idenTipoPergunta);
      this.pergunta.tipoPergunta.siglTipoPergunta = stringFixed;
      this.pergunta.tipoPergunta.statPergunta = 'ATIVO';
      this.pergunta.idenPergunta = data.idenPergunta;
      this.pergunta.descPergunta = data.descPergunta;
      this.pergunta.statPergunta = 'ATIVO';
      this.tipoSelecionado = this.pergunta.tipoPergunta;
      this.exibirEditarPergunta = true;
    },
      mostrarExcluirCategoria(data) {
      this.novaCategoria = data;
      this.exibiExcluirCategoria = true;
    },
    mostrarExcluirPergunta(data) {
      this.pergunta.tipoPergunta.idenTipoPergunta = data.idenTipoPergunta;
      this.pergunta.idenPergunta = data.idenPergunta;
      this.pergunta.descPergunta = data.descPergunta;
      this.pergunta.statPergunta = 'ATIVO';
      this.tipoSelecionado = this.pergunta.tipoPergunta;
      this.exibirExcluirPergunta = true;
    },
    mostrarOpcaoPergunta(data) {
      data = {...data, tipoPergunta : {idenTipoPergunta : data}}
      this.$store.commit('setPerguntaSelecionada', data)
      this.$router.push({name:'manterOpcoesPergunta'})
    },
    slugify(iden) {
     switch (iden) {
       case 6:
         return "OPCAOMULTIPLA";
       case 5:
         return "OPTEST2";
       case 4:
         return "LISTA";
       case 3:
         return "OPCAOUNICA";
       case 2:
         return "DATA";
       case 1:
         return "TEXTO";              
       default:
         break;
     }
}
  },
  mounted() {
    this.carregarDados();
  },
};
</script>

<style></style>
